export default "__VITE_ASSET__CVRi1alg__"